import React from 'react'
import styled from '@emotion/styled'
import { spacing, Text } from '@retailer-platform/shared-components'
import { type SnowflakeColumn } from '../PublishToSnowflakeForm'
import ColumnMappingRow from './ColumnMappingRow'

interface ColumnMappingTableProps {
  columns: SnowflakeColumn[]
  onChange: (columns: SnowflakeColumn[]) => void
  disabled: boolean
}

const Table = styled.div({
  display: 'grid',
  gridTemplateColumns: 'auto auto auto auto auto 1fr',
  gap: spacing.X32,
  padding: spacing.X16,
})

const Header = styled.div({
  paddingBottom: spacing.X16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const ColumnMappingTable: React.FC<ColumnMappingTableProps> = ({ columns, onChange, disabled }) => {
  const onColumnChange = (index: number, column: SnowflakeColumn) => {
    const newColumns = [...columns]
    newColumns[index] = column
    onChange(newColumns)
  }
  return (
    <Table>
      <>
        <Header>
          <Text weight="bold">Column Name</Text>
        </Header>
        <Header>
          <Text weight="bold">Column Type</Text>
        </Header>
        <Header>
          <Text weight="bold">Is Required</Text>
        </Header>
        <Header>
          <Text weight="bold">Default Value</Text>
        </Header>
        <Header>
          <Text weight="bold">Is Primary Key</Text>
        </Header>
        <Header>
          <Text weight="bold">CAMP field</Text>
        </Header>
        {columns?.map((column, index) => (
          <ColumnMappingRow
            key={'column-' + column.name}
            column={column}
            onChange={column => onColumnChange(index, column)}
            disabled={disabled}
          />
        ))}
      </>
    </Table>
  )
}

export default ColumnMappingTable
